export enum ProductLineEnum {
  CAT = 8,
  CLINICAL_CONDITION = 9
}
